export default __webpack_public_path__ + "static/media/golfcrunchcombined.f589b906.png";